/*
 * @Author: your name
 * @Date: 2021-01-25 13:38:10
 * @LastEditTime: 2024-06-11 17:22:04
 * @LastEditors: Gyan
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\routes\modules\orgPersonnel.js
 */
export default [
  {
    name: 'competency',
    path: '/orgPersonnel/competency',
    component: () => import('@/views/orgPersonnel/competency'),
    meta: {
      title: '人员胜任力'
    }
  },
  {
    name: 'jobCompetence',
    path: '/orgPersonnel/jobCompetence',
    component: () => import('@/views/orgPersonnel/jobCompetence'),
    meta: {
      title: '岗位胜任力'
    }
  },
  {
    name: 'personData',
    path: '/orgPersonnel/personData:id',
    component: () => import('@/views/orgPersonnel/activeList/personData'),
    meta: {
      title: '人员档案',
      parentAuth: '/orgPersonnel/activeList'
    }
  },
  {
    name: 'activeList',
    path: '/orgPersonnel/activeList',
    component: () => import('@/views/orgPersonnel/activeList/activeList.vue'),
    meta: {
      title: '在职花名册'
    }
  },
  {
    name: 'personnelFiles',
    path: '/orgPersonnel/personnelFiles',
    component: () =>
      import('@/views/orgPersonnel/activeList/personData/personnelFiles.vue'),
    meta: {
      title: '人员档案',
      parentAuth: '/orgPersonnel/activeList'
    }
  },
  {
    name: 'personnelFilesPreview',
    path: '/orgPersonnel/personnelFilesPreview',
    component: () =>
      import(
        '@/views/orgPersonnel/activeList/personData/components/personnelFilesPreview.vue'
      ),
    meta: {
      title: '合同预览',
      parentAuth: '/orgPersonnel/activeList'
    }
  },
  {
    name: 'jobDescription',
    path: '/orgPersonnel/jobDescription',
    component: () =>
      import('@/views/orgPersonnel/jobDescription/jobDescriptList'),
    meta: {
      title: '岗位列表'
    }
  },
  {
    name: 'jobDescriptionDetail',
    path: '/orgPersonnel/jobDescriptionDetail',
    component: () =>
      import('@/views/orgPersonnel/jobDescription/jobDescriptionDetail'),
    meta: {
      parentAuth: '/orgPersonnel/jobDescription',
      title: '岗位说明书'
    },
    props: route => ({
      positionNo: route.query.no || route.query.positionNo,
    })
  },
  {
    name: 'departmentManagement',
    path: '/orgPersonnel/departmentManagement',
    component: () =>
      import('@/views/orgPersonnel/departmentManagement/index.vue'),
    meta: {
      title: '部门管理'
    }
  },
  {
    name: 'architecturePreAdjustment',
    path: '/orgPersonnel/architecturePreAdjustment',
    component: () =>
      import(
        '@/views/orgPersonnel/departmentManagement/architecturePreAdjustment/index.vue'
      ),
    meta: {
      title: '架构预调整',
      parentAuth: '/orgPersonnel/departmentManagement'
    }
  },
  {
    name: 'positionAdjustApplication',
    path: '/orgPersonnel/positionAdjustApplication',
    component: () =>
      import(
        '@/views/orgPersonnel/positionAdjustApplication/index.vue'
      ),
    meta: {
      title: '岗位调整申请',
      parentAuth: '/orgPersonnel/jobDescription'
    }
  },
  {
    name: 'positionAdjustApplication',
    path: '/orgPersonnel/positionAdjustApplication/adjustId/:adjustId',
    component: () =>
      import(
        '@/views/orgPersonnel/positionAdjustApplication/index.vue'
      ),
    meta: {
      title: '岗位调整申请',
      parentAuth: '/orgPersonnel/jobDescription'
    }
  },
  {
    name: 'transferRecord',
    path: '/orgPersonnel/personnelManagement/transferRecord',
    component: () =>
      import(
        '@/views/orgPersonnel/personnelManagement/transferRecord/index.vue'
      ),
    meta: {
      title: '异动记录'
    }
  },
  {
    name: 'reemploymentBlackList',
    path: '/orgPersonnel/personnelManagement/reemploymentBlackList',
    component: () =>
      import(
        '@/views/orgPersonnel/personnelManagement/transferRecord/reemploymentBlackList.vue'
      ),
    meta: {
      title: '再入职黑名单'
    }
  },
  {
    name: 'rewardPunishmentLedger',
    path: '/orgPersonnel/personnelManagement/rewardPunishmentLedger',
    component: () =>
      import(
        '@/views/orgPersonnel/personnelManagement/transferRecord/rewardPunishmentLedger.vue'
      ),
    meta: {
      title: '奖惩台账'
    }
  },
  {
    name: 'insiderList',
    path: '/orgPersonnel/personnelManagement/insiderList',
    component: () =>
      import(
        '@/views/orgPersonnel/personnelManagement/transferRecord/insiderList/index.vue'
      ),
    meta: {
      title: '内部关系人'
    }
  },
  {
    name: 'employeeLabelList',
    path: '/orgPersonnel/employeeLabelList',
    component: () =>
      import(
        '@/views/orgPersonnel/employeeLabelList/index.vue'
      ),
    meta: {
      title: '标签管理'
    }
  }
];
